module.exports = __webpack_public_path__ + "static/media/account-creation.9b530f02.svg";